import { render, staticRenderFns } from "./DealsStage.vue?vue&type=template&id=3dac2673&scoped=true"
import script from "./DealsStage.vue?vue&type=script&lang=js"
export * from "./DealsStage.vue?vue&type=script&lang=js"
import style0 from "./DealsStage.vue?vue&type=style&index=0&id=3dac2673&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac2673",
  null
  
)

export default component.exports